/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import '../TrustedServices/TrustedServices.css';
import { toast } from 'react-toastify';
import {
  sess_delete, sess_post, POST,
} from '../../../utils/HttpRequests';

const ALOHAA_VMN_URL = process.env.REACT_APP_VMN_API;
const CENTRAL_VMN_URL = process.env.REACT_APP_CENTRAL_VMN_API;
// const API_URL = process.env.REACT_APP_API_URL;

const SearchVMNManagement = (props) => {
  const [show, setShowModal] = useState(false);
  const {
    title, url, name, method, vmn,
  } = props;
  const [file, setFile] = useState('');
  const [error, setError] = useState('');

  const handleSuccess = async () => {
    try {
      if (!file) {
        setError('Please select a file to upload.');
        return;
      }
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      if (vmn === 'central' && method === 'upload') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'csv');
        await POST(`${CENTRAL_VMN_URL}${url}`, formData)
          .then((response) => {
            const res = response?.data?.response?.status;
            setError('');
            toast.success(res || 'Uploaded Successfully');
          }).catch((err) => {
            const reason = err?.response?.data?.error?.reason;
            // eslint-disable-next-line
            console.error({ err }); setError(reason || 'Upload Failed');
          });
      }
      if (vmn === 'central' && method === 'delete') {
        const formData = new FormData();
        formData.append('file', file);
        await POST(`${CENTRAL_VMN_URL}${url}`, formData)
          .then((response) => {
            const res = response?.data?.response?.status;
            setError('');
            toast.success(res || 'Deleted Successfully');
          }).catch((err) => {
            const reason = err?.response?.data?.error?.reason;
            // eslint-disable-next-line
            console.error(err); setError(reason || 'Delete Failed');
          });
      }
      if (vmn === 'alohaa' && method === 'upload') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'csv');
        await POST(`${ALOHAA_VMN_URL}${url}`, formData)
          .then((response) => {
            const res = response?.data?.response?.status;
            setError('');
            toast.success(res || 'Uploaded Successfully');
          }).catch((err) => {
            const reason = err?.response?.data?.error?.reason;
            // eslint-disable-next-line
            console.error({ err }); setError(reason || 'Upload Failed');
          });
      }
      if (vmn === 'alohaa' && method === 'delete') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'csv');
        await POST(`${ALOHAA_VMN_URL}${url}`, formData)
          .then((response) => {
            const res = response?.data?.response?.status;
            setError('');
            toast.success(res || 'Deleted Successfully');
          }).catch((err) => {
            const reason = err?.response?.data?.error?.reason;
            // eslint-disable-next-line
            console.error(err); setError(reason || 'Delete Failed');
          });
      }
      if (method === 'releasevmns') {
        const formData = new FormData();
        formData.append('vmns_file', file);
        const response = await sess_post(url, sessionToken, formData);
        if (response.data && response.data.success) {
          if (response?.data?.response?.issue_vmns) {
            const { issue_vmns } = response.data.response;
            let csvstring = '';
            for (let i = 0; i < issue_vmns.length; i += 1) {
              csvstring = `${csvstring + issue_vmns[i]}\n`;
            }
            const blob = new Blob([csvstring], { type: 'text/csv' });
            const URL = window.URL || window.webkitURL;
            const downloadFileUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadFileUrl;
            a.download = 'issue_vmns.csv';
            a.style = 'display:none';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setError('issue_vmns found');
          } else {
            setError('Uploaded successfully');
          }
        }
      }

      if (vmn === 'doosra') {
        const formData = new FormData();
        formData.append('vmns_file', file);
        if (method === 'delete') {
          const response = await sess_delete(url, sessionToken, formData);
          if (response.data && response.data.success) {
            if (response?.data?.response?.allotted_vmns?.length > 0) {
              const allotted_list = response.data.response.allotted_vmns;
              let csvstring = '';
              for (let i = 0; i < allotted_list.length; i += 1) {
                csvstring = `${csvstring + allotted_list[i]}\n`;
              }
              const blob = new Blob([csvstring], { type: 'text/csv' });
              const URL = window.URL || window.webkitURL;
              const downloadFileUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = downloadFileUrl;
              a.download = 'allotted_vmns_list.csv';
              a.style = 'display:none';
              document.body.appendChild(a);
              a.click();
              a.remove();
              setError('Allotted VMNs found!');
            } else {
              setError('Deleted successfully');
            }
          }
        } else {
          const response = await sess_post(url, sessionToken, formData);
          if (response.data && response.data.success) {
            if (response?.data?.response?.is_duplicates_found) {
              const duplicates = JSON.parse(response.data.response.duplicates);
              let csvstring = '';
              for (let i = 0; i < duplicates.length; i += 1) {
                csvstring = `${csvstring + duplicates[i].v_mobile_no},${duplicates[i].is_used},${duplicates[i].is_premium}\n`;
              }
              const blob = new Blob([csvstring], { type: 'text/csv' });
              const URL = window.URL || window.webkitURL;
              const downloadFileUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = downloadFileUrl;
              a.download = 'duplicates.csv';
              a.style = 'display:none';
              document.body.appendChild(a);
              a.click();
              a.remove();
              setError('Duplicates found');
            } else {
              const res = response?.data?.response?.status;
              setError('');
              toast.success(res || 'Uploaded Successfully');
            }
          }
        }
      }

      setTimeout(() => { setShowModal(false); setError(''); }, 5000);
    } catch (err) {
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in update category price');
    }
  };

  return (
    <>
      <Button
        onClick={(e) => {
          e.preventDefault();
          setShowModal(true);
        }}
        variant={name === 'Delete' ? 'danger' : 'success'}
      >
        {name}
      </Button>
      <Modal
        show={show}
        onHide={() => { setShowModal(false); }}
        dialogClassName="search-vmn-modal"
      >

        <Modal.Title>{title}</Modal.Title>
        <Modal.Body>
          <div style={{ borderBottom: 'solid 1px' }}>
            <input type="file" accept=".csv" onChange={(e) => { setFile(e.target.files[0]); }} />
            {error && <div style={{ color: 'red' }}>{error}</div>}
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setShowModal(false);
              setError('');
            }}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            style={{
              color: '#fff',
              backgroundColor: name === 'Delete' ? '#dc3545' : '#5cb85c',
              borderColor: name === 'Delete' ? '#dc3545' : '#4cae4c',
            }}
            onClick={handleSuccess}
          >
            {name}
          </Button>

        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SearchVMNManagement;